module.exports = __webpack_public_path__ + "static/media/exacta1.142fa6f9.png";